import { createAction, props } from '@ngrx/store';

import { MyReportListPagination, MyReportSearchCriteria } from '../../models/my-report';

export const myReportListRequest = createAction(
  '[My Report] MyReports request list',
  props<{ payload: MyReportSearchCriteria }>()
);

export const myReportListResponse = createAction(
  '[My Report] MyReports response list',
  props<{ data: MyReportListPagination }>()
);
